import { boolean, id, string } from "@moirei/dobby";
import type { Dayjs } from "dayjs";
import {
  type BioSiteData,
  type BioSiteApi,
  type BioSite as IBioSiteBase,
  BioSiteStatus,
} from "~/components/pages/bio-site/BioSitePage/remote";
import { Model, datetime, mixed } from "~/layers/admin/models/dobby";

export interface IBioSite extends IBioSiteBase {
  gid: string;
  url: string;
}

export interface BioSiteFileUploadInput {
  key: string;
  file: Blob | File;
}

export class BioSite extends Model implements IBioSite {
  static override entity = "BioSite";
  static override primaryKey = "handle";

  @datetime() declare readonly created_at: Dayjs;
  @datetime() declare readonly updated_at?: Dayjs;
  @id() declare readonly id: string;
  @id() declare readonly gid: string;
  @string() declare readonly status: BioSiteStatus;
  @id() declare readonly handle: string;
  @string() declare readonly name: string;
  @string() declare readonly url: string;
  @string() declare workspace?: string;
  @boolean() declare verified: boolean;
  @mixed() declare api: BioSiteApi;
  @mixed() declare data: BioSiteData;
  @mixed() declare resources: any;

  public $isActive() {
    return [BioSiteStatus.ACTIVE, BioSiteStatus.UNPUBLISHED_CHANGES].includes(
      this.status
    );
  }

  public async $toggleActive() {
    const status = await this.$newQuery()
      .select("status")
      .where("where", {
        type: "BioSiteWhereUniqueInput",
        required: true,
        value: this.$getWhere(),
      })
      .parseWith((response) => response.data.wsToggleActiveBioSite?.status)
      .mutate("wsToggleActiveBioSite");

    if (status) {
      this.$fillOriginal({ status });
    }

    return !!status;
  }

  public getTransfer(): IBioSite {
    return {
      gid: this.gid,
      name: this.name,
      url: this.url,
      handle: this.handle,
      workspace: this.workspace,
      status: this.status,
      verified: this.verified,
      api: this.api,
      data: {
        ...{ name: this.name },
        ...this.data,
      },
      resources: {
        ...this.resources,
      },
    };
  }
}
